export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true
};
export const PageName = '拼团房间列表';